module.exports = __webpack_public_path__ + "img/2022-06.e7d706a0.jpg";